/* global Image */
export default function VdBgImageDirective() {
  return {
    restrict: 'AE',
    link(scope, $element, tAttrs) {
      const options = scope.$eval(tAttrs.vdBgImage) || {}

      if (!options.image) {
        return undefined
      }

      const backgroundImage = new Image()

      backgroundImage.addEventListener(
        'load',
        function () {
          const { width, height } = $element[0].getBoundingClientRect()
          const containerIsPortrait = height > width
          const imageIsPortrait = this.naturalHeight > this.naturalWidth

          const backgroundSize =
            (containerIsPortrait && !imageIsPortrait) ||
            (!containerIsPortrait && imageIsPortrait)
              ? 'contain'
              : 'cover'

          const imageStyle = `
            background-image: url(${options.image});
            background-repeat: no-repeat;
            background-position: center;
            background-size: ${backgroundSize};
          `

          $element.attr('style', imageStyle)
        },
        false
      )

      backgroundImage.src = options.image
    },
  }
}
